if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const dtLoader = document.createElement('div');
      dtLoader.className = 'dT_loading';
      dtLoader.innerHTML = `<div class="loading"></div>`;
      
      setTimeout( () => {
        $('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
      }, 2000);
      
      setTimeout( () => {
        $('.main-product_info').removeClass('quick-add-modal-in-progress');
      }, 4000);
      
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          this.preventDuplicatedIDs();        
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();         
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');   
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });

      // Initialize product form functionality for quick view - simplified approach
      setTimeout(() => {
        this.initializeQuickViewForm(element);
      }, 300);
    }

    initializeQuickViewForm(container) {
      console.log('Initializing quick view form...');
      
      // Find the product form wrapper
      const wrapper = container.querySelector('[id^="product-form-wrapper-"]');
      if (!wrapper) {
        console.log('No product form wrapper found');
        return;
      }

      console.log('Product form wrapper found');

      // State variables
      let selectedVariantId = null;
      let selectedVariantAvailable = false;
      let hasBeenSelected = false;
      let activeTab = 'uk';

      // Get DOM elements
      const variantButton = wrapper.querySelector('.variant-selector-button');
      const variantModal = wrapper.querySelector('.variant-modal');
      const selectedText = wrapper.querySelector('.selected-text');
      const hiddenInput = wrapper.querySelector('input[name="id"]');
      const addButton = wrapper.querySelector('.add-to-cart-button');
      const buyButton = wrapper.querySelector('.buy-now-button');
      const form = wrapper.querySelector('.product-form');

      console.log('Elements found:', {
        variantButton: !!variantButton,
        variantModal: !!variantModal,
        selectedText: !!selectedText,
        addButton: !!addButton,
        buyButton: !!buyButton,
        form: !!form
      });

      // Get initial values
      if (hiddenInput && hiddenInput.value) {
        selectedVariantId = hiddenInput.value;
        const variantOption = wrapper.querySelector(`[data-variant-id="${selectedVariantId}"]`);
        if (variantOption) {
          selectedVariantAvailable = variantOption.getAttribute('data-variant-available') === 'true';
          const variantTitle = variantOption.getAttribute('data-variant-title');
          if (selectedText && variantTitle) {
            selectedText.textContent = variantTitle;
            hasBeenSelected = true;
          }
        }
      }

      // Update button states
      const updateButtons = () => {
        const addButtonText = addButton?.querySelector('.button-text');
        
        if (hasBeenSelected && selectedVariantAvailable) {
          if (addButton) addButton.disabled = false;
          if (buyButton) buyButton.disabled = false;
          if (addButtonText) addButtonText.textContent = 'Add to Cart';
        } else if (hasBeenSelected && !selectedVariantAvailable) {
          if (addButton) addButton.disabled = true;
          if (buyButton) buyButton.disabled = true;
          if (addButtonText) addButtonText.textContent = 'Sold Out';
        } else {
          if (addButton) addButton.disabled = true;
          if (buyButton) buyButton.disabled = true;
          if (addButtonText) addButtonText.textContent = 'Select a Size';
        }
      };

      // Handle variant dropdown click - simple approach
      if (variantButton && variantModal) {
        variantButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          console.log('Variant button clicked');
          
          const isOpen = variantModal.style.display === 'block';
          
          if (isOpen) {
            variantModal.style.display = 'none';
            variantButton.classList.remove('active');
            console.log('Closing modal');
          } else {
            variantModal.style.display = 'block';
            variantButton.classList.add('active');
            console.log('Opening modal');
          }
        });

        // Close modal when clicking outside
        document.addEventListener('click', function(e) {
          if (!wrapper.contains(e.target)) {
            variantModal.style.display = 'none';
            variantButton.classList.remove('active');
          }
        });
      }

      // Handle tab switching
      const tabButtons = wrapper.querySelectorAll('.tab-button');
      tabButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const tab = this.getAttribute('data-tab');
          activeTab = tab;
          
          console.log('Tab clicked:', tab);
          
          // Update tab buttons
          tabButtons.forEach(b => b.classList.remove('active'));
          this.classList.add('active');
          
          // Show/hide size displays
          const sizeOptions = wrapper.querySelectorAll('.size-option');
          sizeOptions.forEach(option => {
            const ukSpan = option.querySelector('.uk-size');
            const euSpan = option.querySelector('.eu-size');
            const usSpan = option.querySelector('.us-size');
            
            if (ukSpan && euSpan && usSpan) {
              ukSpan.style.display = tab === 'uk' ? 'inline' : 'none';
              euSpan.style.display = tab === 'eu' ? 'inline' : 'none';
              usSpan.style.display = tab === 'us' ? 'inline' : 'none';
            }
          });
        });
      });

      // Handle size option clicks
      const sizeOptions = wrapper.querySelectorAll('.size-option');
      sizeOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          if (this.disabled) return;
          
          console.log('Size option clicked');
          
          const variantId = this.getAttribute('data-variant-id');
          const variantTitle = this.getAttribute('data-variant-title');
          const variantAvailable = this.getAttribute('data-variant-available') === 'true';
          
          selectedVariantId = variantId;
          selectedVariantAvailable = variantAvailable;
          hasBeenSelected = true;
          
          // Update UI
          if (selectedText) selectedText.textContent = variantTitle;
          if (hiddenInput) hiddenInput.value = variantId;
          
          updateButtons();
          
          // Close modal
          variantModal.style.display = 'none';
          variantButton.classList.remove('active');
          
          console.log('Selected variant:', variantId, variantTitle);
        });
      });

      // Handle form submission
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          
          console.log('Form submitted');
          
          if (!hasBeenSelected || !selectedVariantAvailable) {
            console.log('Cannot submit - no variant selected or not available');
            return;
          }
          
          const addButtonText = addButton?.querySelector('.button-text');
          const addLoadingText = addButton?.querySelector('.loading-text');
          
          if (addButton) addButton.disabled = true;
          if (addButtonText) addButtonText.style.display = 'none';
          if (addLoadingText) addLoadingText.style.display = 'inline';
          
          const formData = new FormData(form);
          if (!formData.has('quantity')) {
            formData.append('quantity', 1);
          }
          
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            if (data.status) {
              console.error('Add to cart error:', data.description);
            } else {
              console.log('Added to cart successfully');
              
              // Success - trigger cart update events
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
              
              // Close quick view modal
              const quickModal = document.querySelector('.quick-add-modal[open]');
              if (quickModal) {
                if (typeof quickModal.hide === 'function') {
                  quickModal.hide();
                } else {
                  quickModal.removeAttribute('open');
                  quickModal.style.display = 'none';
                }
              }
              
              // Show cart notification
              const cartButton = document.querySelector('#cart-icon-bubble');
              if (cartButton) {
                cartButton.click();
              }
            }
          })
          .catch((error) => {
            console.error('Add to cart fetch error:', error);
          })
          .finally(() => {
            if (addButton) addButton.disabled = false;
            if (addButtonText) addButtonText.style.display = 'inline';
            if (addLoadingText) addLoadingText.style.display = 'none';
            updateButtons();
          });
        });
      }

      // Handle buy now button
      if (buyButton) {
        buyButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          console.log('Buy now clicked');
          
          if (!hasBeenSelected || !selectedVariantAvailable) {
            console.log('Cannot buy now - no variant selected or not available');
            return;
          }
          
          const buyButtonText = this.querySelector('.button-text');
          const buyLoadingText = this.querySelector('.loading-text');
          
          this.disabled = true;
          if (buyButtonText) buyButtonText.style.display = 'none';
          if (buyLoadingText) buyLoadingText.style.display = 'inline';
          
          window.location.href = `/cart/${selectedVariantId}:1`;
        });
      }

      // Initial button state
      updateButtons();
      
      console.log('Quick view form initialization complete');
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;      
      variantPicker.setAttribute('data-update-url', 'false');
      
      $('input:radio[name="Color"]').click(function() {      
        $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
        $(this).next('.swatch-element').addClass('clicked');
      });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();      
       
      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();  

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });      
    }

    removeGalleryListSemantic() {      
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');      
      if (!galleryList) return;     
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      
      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');        
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }

  });
}